import { all, call, put, takeLatest } from "redux-saga/effects";

import { downloadBlob } from "helpers/url";
import { ApiManager } from "services/api";
import { RequestAction } from "store/entities/actions";
import { InvoiceActions } from "store/entities/invoices/actions";
import { IDownloadInvoicePayload, IFetchInvoicesCollectionPayload } from "store/entities/invoices/interfaces";
import { IActionWithPayload } from "store/helper";
import { INVOICE, InvoicesViewActions, InvoicesViewActionsNames } from "store/views/invoices/actions";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* fetchInvoices(action: IActionWithPayload<string, IFetchInvoicesCollectionPayload>) {
  const { payload } = action;
  yield put(InvoiceActions.fetchCollection({ ...payload }));
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* downloadInvoice(action: IActionWithPayload<string, IDownloadInvoicePayload>) {
  const {
    payload: { id },
  } = action;

  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.invoiceApi.downloadInvoice, { id });
  if (response.result) {
    const blob = new Blob([response.result]);
    const url = URL.createObjectURL(blob);
    downloadBlob(url, `invoice_${id}.pdf`);

    yield put(InvoicesViewActions.downloadInvoiceSuccess());
  } else {
    yield put(InvoicesViewActions.downloadInvoiceFailure());
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* invoicesViewSagas() {
  yield all([
    takeLatest(InvoicesViewActionsNames.FETCH_INVOICES_VIEW_DATA, fetchInvoices),
    takeLatest(INVOICE.DOWNLOAD[RequestAction.REQUEST], downloadInvoice),
  ]);
}
